import React, { useRef } from 'react';
import { connect } from "react-redux";
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import routes from '../routes';

import NavBar from '../navigation/NavBar';

import { useAuthUser } from './AuthUserContext';

import PurchasePage from '../purchase/PurchasePageContainer';
import SellPage from '../sell/SellPageContainer';
import LedgerPage from '../ledger/LedgerPageContainer';
import AdminPage from '../admin/AdminPage';

const PrivateRoute = ({
}) => {
  const authUser = useAuthUser();
  const isAuthenticated = authUser !== null;

  const ref = useRef(null);

  const pathname = useLocation().pathname;

  const route = 
    <Routes>
      <Route path='/purchase' element={<PurchasePage />}/>
      <Route path='/sell' element={<SellPage />}/>
      <Route path='/ledger' element={<LedgerPage />}/>
      <Route path='/admin' element={<AdminPage />}/>
    </Routes>;

  if (isAuthenticated) {
    return (
      <div ref={ref} className='sans-serif h-100'>
        <div className='flex flex-column' style={{ height: '100%' }}>
          <div className='z-4 navbar-container bg-navy'>
            <div className='bg-custom-navy-20'>
              <NavBar />
            </div>
          </div>
          <div className='bg-white pa0-l'>
            {route}
          </div>
        </div>
      </div>
    );
  } else
    return (
      <Navigate to="/welcome"/>
    );
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(PrivateRoute);
